<div class="holding-container {{notificationData.type}}">
  <span class="notification-symbol">
    @switch (notificationData.type) {
      @case (notificationType.POSITIVE) {
        <i class="fas fa-check"></i>
      }
      @case (notificationType.NEGATIVE) {
        <i class="fas fa-times"></i>
      }
      @case (notificationType.WARNING) {
        <i class="fas fa-exclamation"></i>
      }
    }
  </span>
  <span class="message-container">
    @switch (notificationData.type) {
      @case (notificationType.POSITIVE) {
        <span class="message-class">Success</span>
      }
      @case (notificationType.NEGATIVE) {
        <span class="message-class">Error</span>
      }
      @case (notificationType.WARNING) {
        <span class="message-class">Warning</span>
      }
    }
    <span class="message-emitted">{{notificationString}}</span>
  </span>
  <button mat-mini-fab class="mat-snackbar-close" (click)="snackBarRef.dismiss()">
    <i class="fas fa-times"></i>
  </button>
</div>
